export default __webpack_public_path__ + "static/media/finalChart.fee9657a.png";